module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.broadcastNotification($event)
      }
    }
  }, [(_vm.errorMessage) ? _c('Message', {
    attrs: {
      "message-content": _vm.errorMessage,
      "message-status": "error"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.successMessage) ? _c('Message', {
    attrs: {
      "message-content": _vm.successMessage,
      "message-status": "success"
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Title\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "title"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notification.title),
      expression: "notification.title"
    }],
    attrs: {
      "name": "",
      "required": "",
      "placeholder": "Please enter notification title",
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.notification.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.notification, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Message\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text input_text_long",
    attrs: {
      "id": "message"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notification.message),
      expression: "notification.message"
    }],
    attrs: {
      "name": "",
      "required": "",
      "placeholder": "Please enter notification message",
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.notification.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.notification, "message", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("\n            Notifications\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn_blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Send notifications\n            ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-541da428", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-541da428","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Notifications.vue
// module id = 439
// module chunks = 1